import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

export const seoMeta = {
  title: 'Пликове за завивки от 100% памук | Голям избор от размери | GoToBed',
  description:
    'Пликове за завивки от 100% памук в размери от 120/190 до 300/230. Ранфорс и памучен сатен, изработка по размер. Поръчайте онлайн от GoToBed.'
};

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function SeoHeader() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Пликове за завивки от 100% памук
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Пликове за завивки от 100% памук в голям избор от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Пликовете за завивки от 100% памук са сред най-търсените продукти за спално бельо, защото
          осигуряват комфортен сън, лесна поддръжка и дълготрайност. В категорията на GoToBed ще
          откриете качествени пликове за завивки от висококачествен памук, създадени за ежедневен
          комфорт и стилна визия на спалнята.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Предлагаме богато разнообразие от размери, сред които популярните 140/200, 150/220,
          180/200, 200/200, 200/220 и 250/230, което улеснява избора на точния плик за вашата
          завивка – независимо дали е стандартна или нестандартна.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Колекцията включва както едноцветни пликове за завивки, така и шарени модели, които
          създават уют и завършен вид на спалнята.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако искате да създадете цялостен комплект спално бельо, разгледайте и:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function SeoBody() {
  return <SeoBodyPlikove />;
}

function SeoBodyPlikove() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      {/* H2: Пликове за завивки 100% памук – комфорт и качество */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Пликове за завивки 100% памук – комфорт и качество
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Пликът за завивка е основна част от спалното бельо, която предпазва завивката от
        замърсяване, улеснява поддръжката и осигурява по-голям комфорт по време на сън.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        В GoToBed предлагаме пликове за завивки от 100% памук, изработени от качествени материи и
        подходящи за различни размери завивки – както стандартни, така и нестандартни.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Сред най-предпочитаните размери са плик за завивка 140/200, плик за завивка 150/220, плик за
        завивка 180/200, плик за завивка 200/200 и плик за завивка 200/220.
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Всички модели се изработват в България от внимателно подбрани платове със сертификат
        OEKO-TEX Standard 100, който гарантира безопасност и липса на вредни вещества.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
        Можете да разгледате моделите според вида на плата:
      </Typography>
      <Box sx={{ mb: 4, pl: 2 }}>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/2"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки ранфорс
        </Typography>
        <Typography
          variant="body1"
          component={Link}
          to="/produkti/spalno-belio/plikove-za-zavivka/1/4/1"
          sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
          пликове за завивки памучен сатен
        </Typography>
      </Box>

      <Collapse in={expanded} collapsedSize={0}>
        {/* H2: Голям избор от размери пликове за завивки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Голям избор от размери пликове за завивки
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Едно от основните предимства на нашия магазин е големият избор от размери, което позволява
          лесно да намерите подходящия плик за вашата завивка.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          При поръчка можете да изберете:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>ширина: от 120 см до 300 см</li>
          <li>дължина: от 190 см до 230 см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Това позволява да намерите подходящ плик за завивка за:
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>единични легла</li>
          <li>стандартни двойни легла</li>
          <li>големи семейни завивки</li>
          <li>нестандартни размери</li>
        </Box>

        {/* H2: Популярни размери пликове за завивки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни размери пликове за завивки
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Сред най-търсените размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            'плик за завивка 140/200 (140х200) см',
            'плик за завивка 150/220 (150х220) см',
            'плик за завивка 180/200 (180х200) см',
            'плик за завивка 200/200 (200х200) см',
            'плик за завивка 200/220 (200х220) см',
            'плик за завивка 240/220 (240х220) см',
            'плик за завивка 250/230 (250х230) см'
          ].map((item) => (
            <Typography key={item} variant="body1" sx={{ color: 'text.secondary' }}>
              {item}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи както за единични легла, така и за големи двойни легла и семейни
          завивки.
        </Typography>

        {/* H2: Видове памучни платове */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Видове памучни платове
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Нашите пликове за завивки се изработват от два основни вида памучен плат.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Ранфорс
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ранфорсът е плътен и издръжлив памучен плат, който осигурява:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>добра дишаемост</li>
          <li>устойчивост при многократно пране</li>
          <li>комфорт при ежедневна употреба</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Той е отличен избор за практично и здраво спално бельо.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Памучен сатен
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Памучният сатен е по-фин и гладък памучен плат, който създава по-луксозно усещане.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предимства:
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>мек и гладък допир</li>
          <li>лек естествен блясък</li>
          <li>елегантна визия на спалнята</li>
        </Box>

        {/* H2: Как да изберете правилния плик за завивка */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Как да изберете правилния плик за завивка
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          При избора на плик за завивка е добре да обърнете внимание на няколко основни фактора.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Размер
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Размерът на плика трябва да съответства на размера на завивката. Обикновено е добре да
          изберете плик с 2–5 см и дори повече, за да влиза завивката по-лесно.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Материя
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Най-добрият избор за спално бельо е 100% памук, защото е: дишащ, мек и приятен на допир,
          подходящ за всички сезони.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Поддръжка
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Памучните пликове се перат лесно и издържат на многократно пране, без да губят комфорта
          си.
        </Typography>

        {/* H2: Свиваемост на памучните платове */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Свиваемост на памучните платове
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Както всички изделия от 100% памук, и пликовете за завивки могат да имат естествена
          свиваемост около 4–5% след първите пранета.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Това е нормално свойство на памучните материи като ранфорс и памучен сатен.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Затова е добре:
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>да предвидите няколко сантиметра повече при избора на размер</li>
          <li>да осигурите достатъчно пространство за завивката след пране</li>
        </Box>

        {/* H2: Предимства на нашите пликове за завивки */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Предимства на нашите пликове за завивки
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>&#10004; изработени от 100% памук</li>
          <li>&#10004; избор между ранфорс и памучен сатен</li>
          <li>&#10004; голямо разнообразие от размери</li>
          <li>&#10004; ширина от 120 до 300 см</li>
          <li>&#10004; дължина от 190 до 230 см</li>
          <li>&#10004; подходящи за стандартни и нестандартни завивки</li>
          <li>&#10004; платове със сертификат OEKO-TEX Standard 100</li>
          <li>&#10004; произведени в България</li>
        </Box>

        {/* H2: Какъв размер плик за завивка да изберете */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какъв размер плик за завивка да изберете
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Какъв плик за завивка е подходящ за завивка 200/200?
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          За завивка с размер 200/200 см най-подходящ е плик за завивка 200/200 см или малко
          по-голям размер, например 210/210, за да има достатъчно пространство и завивката да се
          поставя по-лесно.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Какъв плик за завивка се използва за завивка 150/220?
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          При завивка с размер 150/220 см най-често се използва плик за завивка 150/220, който пасва
          точно на завивката. Ако предпочитате повече пространство, можете да изберете и 160/230 см.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Какъв плик за завивка е подходящ за единично легло?
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За единични легла най-популярните размери са:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['140/200', '150/220'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи за стандартни единични завивки.
        </Typography>

        <Typography variant="h6" component="h3" fontWeight={600} sx={{ mb: 1 }}>
          Какъв плик за завивка е подходящ за двойно легло?
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За двойни легла най-често се използват следните размери:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {['200/200', '200/220', '240/220'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>

        {/* H2: Още продукти за вашата спалня */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Още продукти за вашата спалня
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете напълно завършен комплект спално бельо, можете да комбинирате плика за
          завивка с:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi-s-lastik/1/3"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Така лесно можете да съчетаете плик за завивка, чаршаф и калъфки в един стил и да
          създадете уютна и хармонична спалня.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер плик за завивка?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Измерете ширината и дължината на вашата завивка и изберете плик за завивка с малко
            по-голям размер, за да влиза завивката по-лесно. В нашия магазин можете да изберете
            размер чрез: ширина: 120 – 300 см, дължина: 190 – 230 см.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Предлагате ли пликове за големи завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Предлагаме пликове за завивки с ширина до 300 см, подходящи за големи двойни и
            семейни завивки.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Какъв плат да избера – ранфорс или памучен сатен?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            И двата плата са 100% памук. Ранфорс – здрав и издръжлив плат за ежедневна употреба.
            Памучен сатен – по-мек и гладък плат с лек блясък и по-луксозно усещане.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свива ли се пликът за завивка след пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Памучните материи могат да имат естествена свиваемост около 4–5% след първите
            пранета, което е нормално за памучни тъкани.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Къде се изработват пликовете за завивки?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Всички пликове за завивки се изработват в България, специално за всяка поръчка.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Колко време отнема изработката?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Срокът за изработка е 3 – 10 работни дни, като в повечето случаи поръчките са готови в
            рамките на 4 – 7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
